module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":["AWSCognito","CognitoIdentityServiceProvider"],"commonjs2":"aws-sdk/clients/cognitoidentityserviceprovider","commonjs":"aws-sdk/clients/cognitoidentityserviceprovider","amd":"aws-sdk/clients/cognitoidentityserviceprovider"}
// module id = 12
// module chunks = 0